document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector(".js-school-search-wrap[data-search-mode='college-only']");
  if (!wrapper) return;

  const input = wrapper.querySelector('.js-school-search-input');
  const btn = wrapper.querySelector('.search-input--btn-new');
  let activeIdx = -1;

  const normalize = (str) =>
    (str || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();

  const escapeHtml = (str) => {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  };

const getUrlKey = (url) => {
  try {
    return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
  } catch (e) {
    return (url || '').replace(window.location.origin, '').replace(/\/$/, '');
  }
};

  const dedupe = (arr) => {
    const seen = new Set();

    return arr.filter((item) => {
      if (!item || !item.url) return false;

      const key = getUrlKey(item.url);

      if (seen.has(key)) return false;

      seen.add(key);
      return true;
    });
  };

  const logoItems = Array.from(document.querySelectorAll('.logo-bar__item a.logo-bar__link'))
    .map((a) => ({
      title: a.dataset.searchTitle || a.getAttribute('aria-label') || a.textContent.trim(),
      url: a.href
    }))
    .filter((item) => item.title && item.url);

  const schoolItems = [];

  (window.COLLEGE_SCHOOL_INDEX || []).forEach((school) => {
    const schoolName = normalize(school.name);
    const keywords = Array.isArray(school.keywords) ? school.keywords.map(normalize).filter(Boolean) : [];
    const collections = Array.isArray(school.collections) ? school.collections : [];

    collections.forEach((collection) => {
      schoolItems.push({
        title: collection.title,
        url: collection.url,
        schoolName,
        keywords,
        searchText: normalize([
          collection.title,
          school.name,
          keywords.join(' ')
        ].join(' '))
      });
    });
  });

  function scoreItem(item, query) {
    const title = normalize(item.title);
    const searchText = item.searchText || normalize(item.title);

    if (title === query) return 100;
    if (title.startsWith(query)) return 80;
    if (title.includes(query)) return 60;
    if (searchText.includes(query)) return 40;

    return 0;
  }

  function searchCollegeCollections(query) {
    query = normalize(query);
    if (!query) return [];

    let results = [];

    logoItems.forEach((item) => {
      const score = scoreItem(
        {
          ...item,
          searchText: normalize(item.title)
        },
        query
      );

      if (score > 0) {
        results.push({ ...item, score });
      }
    });

    schoolItems.forEach((item) => {
      const score = scoreItem(item, query);

      if (score > 0) {
        results.push({ ...item, score });
      }
    });

    results = dedupe(results);

    return results.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return normalize(a.title).localeCompare(normalize(b.title));
    });
  }

  function clearAutocomplete() {
    const container = wrapper.querySelector('.autocomplete-items');
    if (container) container.remove();
  }

  function renderResults(query) {
    clearAutocomplete();
    activeIdx = -1;

    query = query.trim();
    if (!query) return;

    const container = document.createElement('div');
    container.className = 'autocomplete-items';
    input.parentNode.appendChild(container);

    const results = searchCollegeCollections(query);

    if (results.length) {
      results.forEach((collection) => {
        const item = document.createElement('div');
        item.className = 'collection-item';
        item.innerHTML = escapeHtml(collection.title);
        item.addEventListener('click', () => {
          window.location.href = collection.url;
        });
        container.appendChild(item);
      });
    } else {
      const empty = document.createElement('div');
      empty.className = 'is-empty';
      empty.innerHTML = `No matching results for: <strong>${escapeHtml(query)}</strong>`;
      container.appendChild(empty);
    }
  }

  input.addEventListener('input', function (e) {
    renderResults(e.target.value);
  });

  input.addEventListener('keydown', function (e) {
    const items = wrapper.querySelectorAll('.collection-item');

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (!items.length) return;
      activeIdx = (activeIdx + 1) % items.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (!items.length) return;
      activeIdx = (activeIdx - 1 + items.length) % items.length;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIdx > -1 && items[activeIdx]) {
        items[activeIdx].click();
      } else {
        const first = searchCollegeCollections(input.value)[0];
        if (first && first.url) window.location.href = first.url;
      }
      return;
    } else {
      return;
    }

    items.forEach((item) => item.classList.remove('autocomplete-active'));
    if (items[activeIdx]) items[activeIdx].classList.add('autocomplete-active');
  });

  btn?.addEventListener('click', function (e) {
    e.preventDefault();
    const first = searchCollegeCollections(input.value)[0];
    if (first && first.url) window.location.href = first.url;
  });

  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) clearAutocomplete();
  });
});